<style>
    .datetime ul{
        overflow: auto!important;
    }
    .datetime ul li{
        float: none!important;
        width: 100%!important;
        margin: 0!important;
        padding: 0!important;
        text-align: center!important;
        border-bottom:0!important;
        background:#fff;
    }
    .datetime ul li:nth-child(odd) {
        border-right: 0!important;
        box-sizing: border-box;
    }
    .datetime ul li a {
        display: block;
        color: #444;
    }
</style>

<template>
  <van-popup class="datetime" v-model="isShow" position="bottom" @click-overlay="closeDatetimePicker">
    <van-datetime-picker
      v-model="currentDateVal"
      :type="dateType"
      @cancel="closeDatetimePicker"
      @confirm="closeDatetimePicker"
    />
  </van-popup>
</template>
<script>
  import { DatetimePicker } from 'vant';
  export default {
    name: "datetimePicker",
    props: {
      'isShowDatetimePicker': {
        default: false,
        type: Boolean
      },
      'dateType': {
        default: 'date',
        type: String
      },
      'currentDate': {
        default: new Date(),
        type: Date
      }
    },
    components: {
      [DatetimePicker.name]: DatetimePicker
    },
    watch: {
      currentDate(val) {
        this.currentDateVal = val;
      },
      isShowDatetimePicker(val) {
        this.isShow = val
      }
    },
    data() {
      return {
        isShow: this.isShowDatetimePicker,
        currentDateVal: new Date()
      }
    },
    mounted() {
      
    },
    methods: {
      //取消，关闭
      closeDatetimePicker(data) {
        this.$emit('closeDatetimePicker', data);
      }
    }
  }
</script>

